/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInvoicesResult } from '../../models/get-invoices-result';

export interface ApiBillingInvoicesPendingGet$Params {

/**
 * Space to act in. Omit to use the user's default space. Must be a space the user belongs to, otherwise the request is rejected.
 */
  'x-space-id'?: string;
}

export function apiBillingInvoicesPendingGet(http: HttpClient, rootUrl: string, params?: ApiBillingInvoicesPendingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInvoicesResult>> {
  const rb = new RequestBuilder(rootUrl, apiBillingInvoicesPendingGet.PATH, 'get');
  if (params) {
    rb.header('x-space-id', params['x-space-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInvoicesResult>;
    })
  );
}

apiBillingInvoicesPendingGet.PATH = '/api/Billing/invoices/pending';
